import { useUpdateWorkOrderItem } from '@/core/domain/workorder/WorkOrdersItems/WorkOrdersItems.hooks';
import { useWorkorderDetailContext } from '../../../WorkorderDetailProvider';
import { WorkOrderItemData } from '../index';
import { UpdateWorkOrderItemRequest } from '@/core/domain/workorder/WorkOrdersItems/WorkOrdersItems.types';

interface RequestParams<T extends keyof UpdateWorkOrderItemRequest> {
  key: T;
  value: UpdateWorkOrderItemRequest[T];
}

export default function useWorkOrderItemUpdate(item?: WorkOrderItemData) {
  const {
    workorder: { data: workorder },
    complement: { data: complement },
  } = useWorkorderDetailContext();

  const update = useUpdateWorkOrderItem(workorder?.id, complement?.id);

  const mutateAsync = async <T extends keyof UpdateWorkOrderItemRequest>(
    request: RequestParams<T>,
  ) => {
    if (complement?.id && item) {
      await update.mutateAsync({
        itemId: item.id,
        isInternal: item.isInternal,
        supplierId: item.supplier?.id,
        workOrderComplementId: complement.id,
        isPaintedPart: item?.isPaintedPart,
        unitCost: item.unitCost,
        itemName: item.description,
        subAreaId: item?.subArea?.id,
        manufacturerId: item?.manufacturer?.id,
        quantity: item.quantity,
        unitPrice: item.unitPrice,
        discount: item.discount,
        [request.key]: request.value,
      });
    }
  };

  return { isLoading: update.isLoading, mutateAsync };
}
